import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

// Before is used as a white mask on top of the component's red background, creating an "incomplete" rectangle effect
// the pixels substracted apply the possitioning of the mask to get the desired effect.
export const HighlightContent = styled.div`
  border: 2px solid ${palette.softRed};
  position: relative;
  padding: 60px 100px;
  margin: 0px 50px 4rem;
  position: relative;

  &:before {
    position: absolute;
    content: "";
    background: ${palette.white};
    height: calc(100% - 60px);
    width: calc(100% + 20px);
    top: 30px;
    left: -10px;

    @media all and (max-width: ${layout.md}) {
      height: calc(100% - 20px);
      top: 10px;
    }
  }

  @media all and (max-width: ${layout.md}) {
    padding: 20px 16px;
    margin: 0px 10px 4rem;
  }
`

export const HighlightText = styled.div`
  display: grid;
  position: relative;
  z-index: 2;

  a {
    color: ${palette.text};
    text-decoration: none;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: ${palette.snowFlower}
    }
  }

  p {
    & > span, & > em {
      font-weight: 300;
    }
  }
`

export const HighlightBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 1;

  &:before {
    position: absolute;
    content: "";
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: contain;
    height: 75px;
    width: 27px;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMS45IDYyLjEiPjxwYXRoIGQ9Ik0yMy42IDMuOUwwIDBsMTkuNyAyNy43IDMuOS0yMy44eiIgZmlsbD0iIzgwZDFjZCIvPjxwYXRoIGQ9Ik0zMS45IDYxLjJMOS4yIDQzLjVsLTcuMSA5LjEgMS4yIDkuNSAyOC42LS45eiIgZmlsbD0iI2ZmZGY2ZSIvPjwvc3ZnPg==);
    top: 30px;
    right: -18px;

    @media all and (max-width: ${layout.md}) {
      background-color: ${palette.white};
      right: 0;
      left: 0;
      margin-left: auto;
      margin-right: auto;
      -webkit-transform: rotate(-90deg);
      transform: rotate(-90deg);
      height: 48px;
      width: 15px;
      top: -26px;
    }
  }

  &:after {
    position: absolute;
    content: "";
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: contain;
    height: 75px;
    width: 27px;
    background-image: url(data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjkuNzkgNTguMjQiPjxwYXRoIGQ9Ik0yNi40OCA1NC4zN0wyLjkgNTguMjQgMjIuNTYgMzAuNXoiIGZpbGw9IiNjZDM5NWMiLz48cGF0aCBkPSJNMjkuNzkuODdMNy4wOSAxOC41OSAwIDkuNTEgMS4xNyAweiIgZmlsbD0iIzk2MzQ4MSIvPjwvc3ZnPg==);
    bottom: 30px;
    left: -18px;

    @media all and (max-width: ${layout.md}) {
      background-color: ${palette.white};
      bottom: -26px;
      right: 0;
      left: 0;
      margin-left: auto;
      margin-right: auto;
      -webkit-transform: rotate(-90deg);
      transform: rotate(-90deg);
      height: 48px;
      width: 15px;
    }
  }
`
